import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const INDIA_SAFFRON = "#FF9933";
const INDIA_GREEN = "#138808";

const TermsAndConditions = () => {
    const { language } = useLanguage();
    const isMarathi = language === "mr";

    return (
        <Box sx={{ py: 6, backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
            <Container maxWidth="md">
                {/* Title */}
                <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                            color: "#1e293b",
                            position: "relative",
                            display: "inline-block",
                            "&:after": {
                                content: '""',
                                position: "absolute",
                                bottom: -8,
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: { xs: 60, sm: 80 },
                                height: 3,
                                background: `linear-gradient(90deg, ${INDIA_SAFFRON}, ${INDIA_GREEN})`,
                                borderRadius: 2,
                            },
                        }}
                    >
                        {isMarathi ? "अटी व शर्ती" : "Terms and Conditions"}
                    </Typography>
                </Box>

                {/* Intro */}
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? "कृपया आमच्या आपत्ती व्यवस्थापन सेवांचा वापर करण्यापूर्वी या अटी व शर्ती काळजीपूर्वक वाचा. या अटी व शर्ती आमच्या सेवांमध्ये तुमचा प्रवेश आणि वापर नियंत्रित करतात, आणि आमच्या सेवांचा वापर करून तुम्ही या अटी व शर्तींना बांधील राहण्यास सहमती देता. जर तुम्ही या अटी व शर्तींच्या कोणत्याही भागाशी सहमत नसाल, तर तुम्ही आमच्या सेवांचा वापर करू शकत नाही."
                        : `Please read these Terms and Conditions carefully before using our disaster management services. These Terms and Conditions govern your access to and use of our services, and by using our services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these Terms and Conditions, you may not use our services.`}
                </Typography>

                {/* Definitions */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "व्याख्या" : "Definitions"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `a. "आम्ही," "आम्हाला," "आमचे" म्हणजे आपत्ती व्यवस्थापन सेवा प्रदाता.
b. "सेवा" म्हणजे आमच्याकडून प्रदान केल्या जाणाऱ्या आपत्ती व्यवस्थापन सेवा, ज्यात आपत्कालीन प्रतिसाद, आपत्ती पुनर्प्राप्ती, जोखीम मूल्यांकन आणि जोखीम कमी करण्याच्या धोरणांचा समावेश आहे परंतु त्यापुरते मर्यादित नाही.
c. "वापरकर्ता," "तुम्ही," "तुमचे" म्हणजे आमच्या सेवांचा वापर करणारी कोणतीही व्यक्ती किंवा संस्था.`
                        : `a. "We," "us," "our" refers to the disaster management service provider.
b. "Services" refers to the disaster management services provided by us, including but not limited to emergency response, disaster recovery, risk assessment, and mitigation strategies.
c. "User," "you," "your" refers to any individual or entity using our services.`}
                </Typography>

                {/* Service Description */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "सेवेचे वर्णन" : "Service Description"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `a. आमच्या आपत्ती व्यवस्थापन सेवा व्यक्ती, संस्था आणि समुदायांना आपत्ती, आणीबाणी आणि संकटांसाठी तयारी, प्रतिसाद आणि पुनर्प्राप्ती करण्यात मदत करण्यासाठी तयार केल्या आहेत.
b. आम्ही आपत्ती तयारी, प्रतिसाद योजना, स्थलांतर प्रक्रिया आणि इतर संबंधित विषयांवर संसाधने, माहिती आणि मार्गदर्शन प्रदान करतो.
c. प्रभावी आपत्ती व्यवस्थापन सुलभ करण्यासाठी आमच्या सेवांमध्ये तंत्रज्ञान, सॉफ्टवेअर अनुप्रयोग आणि संवाद प्रणालींचा वापर समाविष्ट असू शकतो.`
                        : `a. Our disaster management services aim to assist individuals, organizations, and communities in preparing for, responding to, and recovering from disasters, emergencies, and crises.
b. We provide resources, information, and guidance on disaster preparedness, response plans, evacuation procedures, and other related topics.
c. Our services may include the use of technology, software applications, and communication systems to facilitate effective disaster management.`}
                </Typography>

                {/* User Responsibilities */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "वापरकर्त्याच्या जबाबदाऱ्या" : "User Responsibilities"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `a. आमच्या सेवांचा वापर करताना अचूक आणि अद्ययावत माहिती प्रदान करण्याची जबाबदारी तुमची आहे.
b. तुम्ही आमच्या सेवांचा वापर जबाबदारीने आणि लागू कायदे व नियमांचे पालन करून कराल यास सहमती देता.
c. तुम्हाला समजते की आमच्या सेवा व्यावसायिक आपत्कालीन सेवांचा पर्याय नाहीत, आणि जीवितास धोका असलेल्या परिस्थितीत तुम्ही त्वरित संबंधित आपत्कालीन सेवांशी संपर्क साधावा.`
                        : `a. You are responsible for providing accurate and up-to-date information when using our services.
b. You agree to use our services responsibly and in compliance with applicable laws and regulations.
c. You understand that our services are not a substitute for professional emergency services, and in case of a life-threatening situation, you should contact the appropriate emergency services immediately.`}
                </Typography>

                {/* Limitations of Liability */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "जबाबदारीची मर्यादा" : "Limitations of Liability"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `a. आम्ही अचूक आणि विश्वासार्ह माहिती व संसाधने प्रदान करण्याचा प्रयत्न करतो. तथापि, आम्ही प्रदान केलेल्या माहितीस अचूकता, पूर्णता किंवा विश्वासार्हतेची हमी देत नाही.
b. आमच्या सेवांच्या वापरामुळे किंवा प्रदान केलेल्या माहितींवर अवलंबून राहिल्यामुळे होणाऱ्या कोणत्याही नुकसान, हानी किंवा दुखापतीसाठी आम्ही जबाबदार राहणार नाही.
c. आमच्या सेवांच्या वापरातून किंवा त्यासंबंधित कोणत्याही अप्रत्यक्ष, अनुषंगिक, परिणामी किंवा दंडात्मक नुकसानीसाठी आम्ही जबाबदार राहणार नाही.`
                        : `a.We strive to provide accurate and reliable information and resources. However, we do not guarantee the accuracy, completeness, or reliability of the information provided.
b.We are not responsible for any loss, damage, or injury arising from the use of our services or reliance on the information provided.
c.We shall not be liable for any indirect, incidental, consequential, or punitive damages arising out of or relating to the use of our services.`}
                </Typography>

                {/* Intellectual Property */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "बौद्धिक संपदा" : "Intellectual Property"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `a. आमच्या सेवांशी संबंधित सर्व बौद्धिक संपदा हक्क, ज्यात मजकूर, ग्राफिक्स, लोगो आणि सॉफ्टवेअर यांचा समावेश आहे परंतु त्यापुरते मर्यादित नाही, ते आमचे मालकीचे आहेत किंवा आम्हाला परवाना दिलेले आहेत.
b. आमच्या पूर्व लेखी संमतीशिवाय तुम्ही आमच्या सेवांचा कोणताही भाग पुनरुत्पादित, सुधारित, वितरित किंवा वापरू शकत नाही.`
                        : `a.All intellectual property rights associated with our services, including but not limited to text, graphics, logos, and software, are owned by or licensed to us.
b.You may not reproduce, modify, distribute, or use any part of our services without our prior written consent.`}
                </Typography>

                {/* Privacy and Data Protection */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "गोपनीयता आणि डेटा संरक्षण" : "Privacy and Data Protection"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `a. आम्ही लागू डेटा संरक्षण कायदे आणि आमच्या गोपनीयता धोरणानुसार वैयक्तिक माहिती गोळा आणि प्रक्रिया करतो.
b. आमच्या सेवांचा वापर करून, तुम्ही आमच्या गोपनीयता धोरणात वर्णन केल्याप्रमाणे तुमची वैयक्तिक माहिती गोळा करणे, प्रक्रिया करणे आणि साठवणे यास संमती देता.`
                        : `a. We collect and process personal information in accordance with applicable data protection laws and our Privacy Policy.
b.By using our services, you consent to the collection, processing, and storage of your personal information as described in our Privacy Policy.`}
                </Typography>

                {/* Termination */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "सेवा समाप्ती" : "Termination"}
                </Typography>
                <Typography variant="body1" paragraph>
                    {isMarathi
                        ? `आम्ही कोणत्याही वेळी पूर्वसूचना किंवा जबाबदारीशिवाय आमच्या सेवांवरील तुमचा प्रवेश निलंबित किंवा समाप्त करण्याचा अधिकार राखून ठेवतो.`
                        : `We reserve the right to suspend or terminate your access to our services at any time without prior notice or liability.`}
                </Typography>

                {/* Amendments */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {isMarathi ? "दुरुस्त्या" : "Amendments"}
                </Typography>
                <Typography variant="body1">
                    {isMarathi
                        ? `आम्ही वेळोवेळी या अटी व शर्तींमध्ये बदल किंवा अद्यतन करू शकतो, आणि अद्ययावत आवृत्ती आमच्या वेबसाइटवर प्रकाशित होताच प्रभावी होईल.`
                        : `We may modify or update these Terms and Conditions from time to time, and the updated version will be effective upon posting on our website.`}
                </Typography>
            </Container>
        </Box>
    );
};

export default TermsAndConditions;
